<ng-container>
  <c-container [fluid]="true">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center position-relative">
        <button toggle="visible" cHeaderToggler [cSidebarToggle]="sidebarId" class="ps-1"
          (click)="toggleSidebar()">
          <svg cIcon name="cilMenu" size="lg"></svg>
        </button>

        <!-- ── Champ de recherche mairie ── -->
        <div class="ms-2 position-relative mairie-search-wrapper">
          <input
            type="text"
            class="form-control form-control-sm mairie-search-input"
            [(ngModel)]="mairie_search"
            (input)="on_mairie_search()"
            (focus)="show_mairie_dropdown = true"
            (blur)="on_blur_mairie()"
            [placeholder]="id_mairie ? get_mairie_label() : 'Toutes les mairies'"
          />
          <span *ngIf="id_mairie" class="mairie-clear-btn" (mousedown)="select_mairie('', $event)">×</span>

          <!-- Dropdown résultats -->
          <ul class="mairie-dropdown" *ngIf="show_mairie_dropdown && mairies_filtrees.length > 0">
            <li (mousedown)="select_mairie('', $event)" class="mairie-dropdown-item mairie-all">
              Toutes les mairies
            </li>
            <li *ngFor="let m of mairies_filtrees"
                (mousedown)="select_mairie(m.id_mairie, $event)"
                class="mairie-dropdown-item"
                [class.active]="m.id_mairie == id_mairie">
              {{ m.nom }}
            </li>
          </ul>
        </div>
      </div>

      <c-header-nav class="ms-3 me-sm-4 pt-2 w-100">
        <div class="m-auto pb-3 me-3 clique" (click)="checkForUpdates()">
          {{ api.version.id }}
        </div>

        <!-- ── Cloche Réclamations ── -->
        <c-dropdown *ngIf="api.can('/home/reclamation')" alignment="end" variant="nav-item">
          <button cButton color="transparent" [caret]="false" cDropdownToggle
            class="position-relative p-2 border-0 shadow-none rounded-circle hover-glow"
            style="transition: all 0.2s ease;">
            <svg cIcon name="cilBell" size="xxl"
              [class]="pendingReclamationCount > 0 ? 'text-primary' : 'text-secondary'"></svg>
            <c-badge *ngIf="pendingReclamationCount > 0"
              class="position-absolute top-0 start-100 translate-middle badge-pulse"
              color="primary" shape="rounded-pill"
              style="font-size:0.65rem;min-width:18px;min-height:18px;display:flex;align-items:center;justify-content:center;">
              {{ pendingReclamationCount > 99 ? '99+' : pendingReclamationCount }}
            </c-badge>
          </button>
          <div cDropdownMenu class="reclamation-dropdown-menu">
            <div class="d-flex align-items-center justify-content-between reclamation-dropdown-header px-3 py-2">
              <div class="d-flex align-items-center gap-2">
                <svg cIcon name="cilBell" size="sm" class="text-primary"></svg>
                <span class="fw-bold reclamation-dropdown-title">Réclamations en attente</span>
              </div>
              <span class="badge badge-solid rounded-pill">{{ pendingReclamationCount }}</span>
            </div>
            <div class="reclamation-dropdown-list">
              <ng-container *ngIf="pendingReclamations.length > 0; else noRec">
                <a *ngFor="let rec of pendingReclamations.slice(0, 6)"
                  [routerLink]="['/home/reclamation']" cDropdownItem
                  class="reclamation-dropdown-item text-decoration-none">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="fw-semibold text-dark text-truncate reclamation-dropdown-item-title">
                      {{ rec.motif || rec.titre || 'Sans motif' }}
                    </span>
                    <span class="badge badge-soft rounded-pill ms-2 flex-shrink-0 reclamation-dropdown-item-badge">
                      {{ (rec.cible_reclamation || 'mairie') | titlecase }}
                    </span>
                  </div>
                  <small class="text-muted text-wrap reclamation-dropdown-item-content">
                    {{ rec.contenu?.length > 80 ? (rec.contenu | slice:0:80) + '...' : rec.contenu }}
                  </small>
                  <small class="text-end text-muted mt-1 reclamation-dropdown-item-date">
                    {{ rec.created_at | date:'dd/MM/yyyy HH:mm' }}
                  </small>
                </a>
              </ng-container>
              <ng-template #noRec>
                <div class="reclamation-dropdown-empty text-center">
                  <div class="mb-2">
                    <svg cIcon name="cilCheck" size="xl" class="text-primary"></svg>
                  </div>
                  <p class="mb-0 text-muted small">Aucune réclamation en attente</p>
                </div>
              </ng-template>
            </div>
            <div class="reclamation-dropdown-footer px-3 py-2 text-center">
              <a [routerLink]="['/home/reclamation']"
                class="btn btn-sm btn-primary w-100 fw-semibold reclamation-dropdown-footer-btn">
                Voir toutes les réclamations →
              </a>
            </div>
          </div>
        </c-dropdown>

        <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
      </c-header-nav>
    </div>
  </c-container>
  <c-header-divider></c-header-divider>
</ng-container>

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button cButton color="" [caret]="false" cDropdownToggle class="py-0">
      <c-avatar color="secondary" status="success">
        {{ api.infos?.agent?.prenom?.substring(0, 3) }}
      </c-avatar>
      <span class="titre">
        {{ get_titre().titre }}
        <span class="mairie">{{ get_titre().description }}</span>
      </span>
    </button>
    <ul cDropdownMenu class="pt-0 pr-5 w-auto">
      <li class="click">
        <a [routerLink]="['/home/profil']" cDropdownItem>
          <svg cIcon class="me-2" name="cilUser"></svg>
          Profile
        </a>
      </li>
      <li class="click">
        <a (click)="api.deconnexion()" cDropdownItem>
          <svg cIcon class="me-2" name="cilLockLocked"></svg>
          Déconnexion
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>

<ng-template #notifyDropdown>
    <c-dropdown alignment="end" variant="nav-item">
        <button cButton color="" [caret]="false" cDropdownToggle>
            <svg cIcon class="my-1 mx-2" name="cilBell" size="lg"></svg>
            <c-badge *ngIf="newNotifications?.length" class="position-absolute top-0 end-0" color="primary"
                shape="rounded-pill">
                {{ newNotifications?.length ?? 0 }}
            </c-badge>
        </button>
        <div cDropdownMenu class="pt-0">
            <h6 cDropdownHeader class="bg-light dark:bg-white dark:bg-opacity-10">
                <strong>You have {{ newNotifications?.length ?? 0 }} notifications</strong>
            </h6>
            <a [routerLink]="[]" cDropdownItem>
                <svg cIcon class="me-2 text-success" name="cilUserFollow"></svg>
                New user registered
            </a>
            <a [routerLink]="[]" cDropdownItem>
                <svg cIcon class="me-2 text-danger" name="cilUserUnfollow"></svg>
                User deleted
            </a>
            <a [routerLink]="[]" cDropdownItem>
                <svg cIcon class="me-2 text-primary" name="cilChartPie"></svg>
                Sales report is ready
            </a>
            <a [routerLink]="[]" cDropdownItem>
                <svg cIcon class="me-2 text-primary" name="cilBasket"></svg>
                New client
            </a>
            <a [routerLink]="[]" cDropdownItem>
                <svg cIcon class="me-2 text-primary" name="cilSpeedometer"></svg>
                Server overloaded
            </a>
            <h6 cDropdownHeader class="bg-light dark:bg-white dark:bg-opacity-10">
                <strong>Server</strong>
            </h6>
            <a [routerLink]="[]" cDropdownItem class="d-block">
                <div class="text-uppercase mb-1">
                    <small>
                        <b>CPU Usage</b>
                    </small>
                </div>
                <c-progress thin>
                    <c-progress-bar [value]="25" color="info-gradient"></c-progress-bar>
                </c-progress>
                <small class="text-medium-emphasis">348 Processes. 1/4 Cores.</small>
            </a>
            <a [routerLink]="[]" cDropdownItem class="d-block">
                <div class="text-uppercase mb-1">
                    <small>
                        <b>Memory Usage</b>
                    </small>
                </div>
                <c-progress thin>
                    <c-progress-bar [value]="70" color="primary"></c-progress-bar>
                </c-progress>
                <small class="text-medium-emphasis">11444GB/16384MB</small>
            </a>
            <a [routerLink]="[]" cDropdownItem class="d-block">
                <div class="text-uppercase mb-1">
                    <small>
                        <b>SSD 1 Usage</b>
                    </small>
                </div>
                <c-progress thin>
                    <c-progress-bar [value]="90" color="primary"></c-progress-bar>
                </c-progress>
                <small class="text-medium-emphasis">243GB/256GB</small>
            </a>
        </div>
    </c-dropdown>
</ng-template>